import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/header.css';
import logo from '../../../media/logo.png';
import link1Img from '../../../media/home.png';
import link2Img from '../../../media/courses.png';
import link3Img from '../../../media/new.png';
import link4Img from '../../../media/login.png';
import link5Img from '../../../media/dashboard.png';
import link6Img from '../../../media/logout.png';
import { AuthContext } from '../../../services/authContext';
import ApiService from '../../../services/api';
import AccountPanel from './account_panel';
import CouponReminder from './coupon_reminder';

function Header() {
  const { isAuthenticated, isAdmin, logout } = useContext(AuthContext);
  const [showAccountPanel, setShowAccountPanel] = useState(false);
 


  
  return (
  <>
    <nav className="navbar navbar-expand-lg custom-navbar">
      <div className="container-fluid">

        
        <Link
          className="navbar-brand d-flex align-items-center gap-2"
          to="/"
        >
          <img src={logo} alt="Logo" className="navbar-logo" />
          <span className="logo-text">ACTAFAD</span>
        </Link>

        <button
          className="custom-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">

          <ul className="navbar-nav ms-auto mobile-menu">

            <li className="nav-item">
              <Link className="nav-link custom-link" to="/">
                <img src={link1Img} alt="Home" className="nav-icon" />
                <span>Home</span>
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link custom-link" to="/courses">
                <img src={link2Img} alt="Courses" className="nav-icon" />
                <span>Corsi</span>
              </Link>
            </li>

            <li className="nav-item">

              {isAuthenticated && !isAdmin ? (

                <div
                  className="nav-link custom-link"
                  onClick={() => setShowAccountPanel(true)}
                  style={{ cursor: "pointer" }}
                >
                  <img src={link4Img} alt="User" className="nav-icon" />
                  <span>Account</span>
                </div>

              ) : isAdmin ? (

                <Link
                  className="nav-link custom-link"
                  to="/admin"
                >
                  <img src={link5Img} alt="Admin" className="nav-icon" />
                  <span>Dashboard</span>
                </Link>

              ) : (

                <Link
                  className="nav-link custom-link"
                  to="/create-account"
                >
                  <img src={link3Img} alt="Create Account" className="nav-icon" />
                  <span>Crea Account</span>
                </Link>

              )}

            </li>

            <li className="nav-item">

              {isAuthenticated ? (

                <Link
                  className="nav-link custom-link"
                  to="/"
                  onClick={logout}
                >
                  <img src={link6Img} alt="Logout" className="nav-icon" />
                  <span>Logout</span>
                </Link>

              ) : (

                <Link
                  className="nav-link custom-link"
                  to="/login"
                >
                  <img src={link4Img} alt="Login" className="nav-icon" />
                  <span>Login</span>
                </Link>

              )}

            </li>

          </ul>
        </div>
      </div>
    </nav>

    {isAuthenticated && !isAdmin && (
      <CouponReminder />
    )}

    {showAccountPanel && (
      <AccountPanel
        onClose={() => setShowAccountPanel(false)}
        logout={logout}
      />
    )}
  </>
);
}

export default Header;
